import React, {useEffect, useRef} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useIntl} from 'react-intl';

const NAVIGATE_TO_LOGIN_TIMEOUT = 5000;

export default function HashNotValidView() {
    const timeout = useRef(null);
    const history = useHistory();
    const intl = useIntl();

    useEffect(() => {
        timeout.current = setTimeout(() => {
            history.push('/login');
        }, [NAVIGATE_TO_LOGIN_TIMEOUT]);

        return () => {
            timeout.current && clearTimeout(timeout.current);
        };
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
            }}
        >
            <h1>{intl.formatMessage({id: 'hashNotValidTitle'})}</h1>
            <h5>{intl.formatMessage({id: 'hashRedirectMessage'})}</h5>
            <Link to='/login'>
                <h6>{intl.formatMessage({id: 'hashBackToLogin'})}</h6>
            </Link>
        </div>
    );
}
